import * as yup from "yup";

import { CustomerCardPreferencesFormType } from "@/components/features/ToDos/CustomerCardPage/steps/PreferenceStep/formType";
import { Shape } from "@/core/yup";

import { CustomerCardFormType } from "../../formType";

export const formSchemaPreference = yup.object<{}, Shape<CustomerCardFormType>>({
    preferences: yup.object<{}, Shape<CustomerCardPreferencesFormType>>({
        medicalInfo: yup.bool().when("medicalWarningBypassed", {
            is: false,
            then: (schema) => schema.oneOf([true]),
        }),
        medicalWarningBypassed: yup.bool().oneOf([true]),
    }),
});
